import { AlertCircle } from "lucide-react";
import { useState } from "react";

const DisclaimerBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="bg-amber-50/80 border-b border-amber-200/50 py-2 px-4 relative backdrop-blur-sm">
      <div className="container mx-auto flex items-center justify-center gap-2 text-center">
        <AlertCircle className="w-4 h-4 text-amber-600 flex-shrink-0" />
        <p className="text-xs text-amber-900">
          Nur zur Information. Ersetzt keine ärztliche Beratung.
        </p>
        <button
          onClick={() => setIsVisible(false)}
          className="text-amber-600 hover:text-amber-800 transition-colors flex-shrink-0 ml-2"
          aria-label="Hinweis schließen"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default DisclaimerBanner;
